import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
    selector: 'formly-field-custom-signature',
    template: `
  <div class="d-flex flex-column align-items-center justify-content-center w-100 h-100">
    <div class="signature-preview-pad d-flex flex-column align-items-center justify-content-center">
      <img src="assets/widgets/signature.svg" class="signature-preview-icon" alt="">
      <span class="signature-preview-text">{{ 'MAIN.CONTENT.WORKFLOW.PREVIEW.SIGN-HERE' | translate }}</span>
    </div>
  </div>
  `,
    styles: [`
    .signature-preview-pad {
      width: 100%;
      min-height: 120px;
      border: 1px dashed #b7c2d4;
      border-radius: 10px;
      background-color: #fff;
    }
    .signature-preview-icon {
      width: 30px;
      height: 30px;
      opacity: 0.35;
    }
    .signature-preview-text {
      margin-top: 6px;
      font-size: 12px;
      color: #a1a1a1;
    }
  `],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormlyFieldCustomSignature extends FieldType<FieldTypeConfig> {
  get type() {
    return this.to.type || 'text';
  }
}
